import React from 'react'

import './styles.scss'
const bc = 'wrapper-block'

const WrapperBlock: React.FC<any> = ({ children, ...props }) => {
  return (
    <div className={bc} {...props}>
      {children}
    </div>
  )
}

export default WrapperBlock
